export const LADE_AUSWAHLWERTE_QUESTIONAIRE = "ladeAuswahlwerteQuestionaire";